import {
  attachPerformanceToExercise,
  createDefaultPerformanceSets,
} from './sessionExercisePerformance';

export function mapRoutineItemToExerciseState(item, index) {
  const typeId = item.exercise_type_id ?? `type-${item.exercise_type_name || 'Exercise'}`;
  const base = {
    id: `re-${item.id ?? index}-${item.exercise_id}`,
    routine_item_id: item.id ?? null,
    exercise_id: item.exercise_id,
    exercise_name: item.exercise_name,
    exercise_type: item.exercise_type_name || 'Exercise',
    exercise_type_id: typeId,
    sets: item.sets ?? 1,
    reps: item.reps ?? 1,
    is_time_based_exercise: item.is_time_based_exercise,
    is_height_based: item.is_height_based,
    is_weight_based: item.is_weight_based,
    time: item.time ?? null,
    display_url: item.display_url ?? null,
    display_images: item.display_images ?? null,
    description: item.description ?? null,
    performance_sets: createDefaultPerformanceSets(item.sets ?? 1, item.reps ?? 1, item),
  };
  return attachPerformanceToExercise(base);
}

export function buildExerciseTypesFromRoutineItems(items) {
  const sorted = [...(Array.isArray(items) ? items : [])].sort(
    (a, b) => (a.order_index ?? 0) - (b.order_index ?? 0)
  );
  const byType = new Map();
  sorted.forEach((item, index) => {
    const mapped = mapRoutineItemToExerciseState(item, index);
    const key = String(mapped.exercise_type_id);
    if (!byType.has(key)) {
      byType.set(key, {
        id: `type-${key}`,
        exercise_type_id: mapped.exercise_type_id,
        exercise_type_name: mapped.exercise_type,
        exercises: [],
      });
    }
    byType.get(key).exercises.push(mapped);
  });
  return Array.from(byType.values());
}

export function flattenExerciseTypesToRoutineItems(exerciseTypes) {
  const items = [];
  (Array.isArray(exerciseTypes) ? exerciseTypes : []).forEach((typeGroup) => {
    (typeGroup.exercises || []).forEach((ex) => {
      if (ex?.exercise_id != null) {
        items.push({ exercise_id: ex.exercise_id, order_index: items.length });
      }
    });
  });
  return items;
}

export function flattenExerciseTypesToExercises(exerciseTypes) {
  const flat = [];
  (Array.isArray(exerciseTypes) ? exerciseTypes : []).forEach((typeGroup) => {
    (typeGroup.exercises || []).forEach((ex) => flat.push(ex));
  });
  return flat;
}
